import { log } from './logger';

export type UserMessage = {
  title: string;
  description?: string;
};

function toUserMessage(err: unknown): UserMessage {
  const fallback: UserMessage = {
    title: 'Something went wrong',
    description: 'Please try again. If the problem persists, contact support.',
  };
  if (!err) return fallback;
  const msg = (typeof err === 'string' ? err : (err as any)?.message) || '';
  if (msg.includes('permission-denied')) {
    return { title: 'Action not allowed', description: 'You may not have permission to do that.' };
  }
  if (msg.includes('unavailable')) {
    return { title: 'Service temporarily unavailable', description: 'Please try again shortly.' };
  }
  if (msg.includes('not-found')) {
    return { title: 'Not found', description: 'The requested item no longer exists.' };
  }
  return fallback;
}

export async function handleError(
  err: unknown,
  context?: Record<string, unknown>,
  quizId?: string,
  showToast?: (m: UserMessage) => void
) {
  const userMsg = toUserMessage(err);
  const errorMessage = (typeof err === 'string' ? err : (err as any)?.message) || 'Unknown error';
  const errorCode = (err as any)?.code || undefined;
  
  await log.error('error_handled', {
    message: errorMessage,
    error: errorMessage,
    errorCode,
    ...context,
    quizId
  });
  
  if (showToast) showToast(userMsg);
}


